import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConferenceStatResource } from 'src/app/models/iconference.interface';
import { MessageToastService } from 'src/app/services/common/message-toast.service';
import { ConferenceService } from 'src/app/services/data/conference.service';

@Component({
  selector: 'app-conf-stat-tabs',
  templateUrl: './conf-stat-tabs.component.html',
  styleUrl: './conf-stat-tabs.component.css'
})
export class ConfStatTabsComponent {
  @Input() data: ConferenceStatResource;
  @Output() renamed = new EventEmitter<boolean>();

  activePanel: number = 0;

  onTabChanged(e: any) {
    this.activePanel = e.index;
  }
}
